import { render, staticRenderFns } from "./InputSearchBase.vue?vue&type=template&id=23761a7f&"
import script from "./InputSearchBase.vue?vue&type=script&lang=js&"
export * from "./InputSearchBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports